import { AddSquareIcon, Cancel01Icon, Image02Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import React from "react";
import { Badge, Button, Card, Col, Row } from "react-bootstrap";
import SportFilter from "../../../../admin/admincomponent/sportFilter/SportFilter";
export default function EditSections({
  userData,
  userProfileImage,
  medicalHistory,
  sections,
  onAddSection,
  onRemoveSection,
  onFieldChange,
  onValueChange,
  onFileChange,
  onSubmit,
  isSubmitting,
  onPhotoFileChange,
  validationErrors = {},
  clearValidationError = () => { },
  kitSizeList = [],
  stateList = [],
  districtList = [],
  onStateChange = () => { },
  restrictedStateId = null,
  onFileRemove = () => { },
  mainCategories = [],
  categoryTypes = {},
  subCategories = {},
  onCategoryMainChange = () => { },
  onCategoryTypeChange = () => { },
}) {

  const categoryType = localStorage.getItem("category_type");

  const shoeSizingGuide = [
    { uk: "3", eu: "35.5", us: "4", inches: "8.8", cm: "22.4" },
    { uk: "4", eu: "37", us: "5", inches: "9.2", cm: "23.3" },
    { uk: "5", eu: "38", us: "6", inches: "9.5", cm: "24.1" },
    { uk: "6", eu: "39", us: "7", inches: "9.8", cm: "24.9" },
    { uk: "7", eu: "40.5", us: "8", inches: "10.2", cm: "25.7" },
    { uk: "8", eu: "42", us: "9", inches: "10.5", cm: "26.6" },
    { uk: "9", eu: "43", us: "10", inches: "10.8", cm: "27.4" },
    { uk: "10", eu: "44.5", us: "11", inches: "11.2", cm: "28.2" },
  ];

  let availableFields = [
    { value: "name", label: "Name" },
    { value: "dob", label: "Date Of Birth" },
    { value: "address", label: "Address" },
    { value: "state", label: "State" },
    { value: "profile", label: "Profile Image" },
    { value: "identification", label: "Identification" },
    { value: "kit_size", label: "Kit Size" },
    { value: "shoe_size", label: "Shoe Size" },
    { value: "height", label: "Height" },
    { value: "weight", label: "Weight" },
    { value: "blood_group", label: "Blood Group" },
    { value: "bank_details", label: "Bank Details" },
    { value: "sport", label: "Sport" },
    { value: "user_type", label: "User Type" },
  ];

  if (categoryType === "9") {
    const restrictedFields = ["identification", "address", "kit_size", "shoe_size", "bank_details"];
    availableFields = availableFields.filter(field => !restrictedFields.includes(field.value));
  }

  // Restrict 'state' for Citizen (9) and Support Staff (2)
  if (categoryType === "9" || categoryType === "2") {
    availableFields = availableFields.filter(field => field.value !== "state");
  }

  const getFieldErrors = (id, keywords = []) => {
    const msgs = (validationErrors?.[id]?.messages) || [];
    if (!keywords.length) return msgs;
    return msgs.filter((m) =>
      keywords.some((k) => m.toLowerCase().includes(k.toLowerCase()))
    );
  };

  const handleRemoveFile = (sectionId) => {
    onFileRemove(sectionId);
  };

  console.log(sections);
  console.log(stateList);
  console.log(districtList);


  return (
    <Card className="p-4 mt-4">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="user-header mb-0">Edit Personal Details</h5>
          <Badge bg="light" text="success">
            Updated
          </Badge>
        </div>

        <form onSubmit={onSubmit}>
          {sections.map((section, idx) => {
            const selectedFields = sections.map((s) => s.field).filter(Boolean);
            const filteredFields = availableFields.filter(
              (item) => !selectedFields.includes(item.value) || item.value === section.field
            );

            return (
              <div key={section.id} className="border rounded p-3 mb-3" style={{ position: "relative" }}>
                {(idx !== 0 || section.field) && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => {
                      if (idx === 0) {
                        onFieldChange(section.id, "");
                        Object.keys(section.values).forEach(key => {
                          onValueChange(section.id, key, "");
                        });
                        clearValidationError(section.id);
                      } else {
                        onRemoveSection(section.id);
                      }
                    }}
                    className="remove-btn"
                  >
                    Remove Details <HugeiconsIcon icon={Cancel01Icon} />
                  </Button>
                )}

                <Row className="g-3">
                  <Col md={6}>
                    <label className="edit-form-label">Select Field</label>
                    <select
                      className="form-select bg-white w-50 p-2"
                      value={section.field}
                      onChange={(e) => {
                        onFieldChange(section.id, e.target.value);
                        clearValidationError(section.id);
                      }}
                    >
                      <option value="" disabled>Select Here</option>
                      {filteredFields.map((item) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                      ))}
                    </select>
                    <div className="edit-form-text">Choose the detail you want to update</div>
                  </Col>

                  {/* Only show fields when a field is selected */}
                  {section.field && (
                    <>
                      {section.field === "name" && (
                        <>
                          <Col xs={12} />
                          <Col md={4}>
                            <label className="form-label">First Name <span className="text-danger">*</span></label>
                            <input
                              className="form-control"
                              type="text"
                              value={section.values.first_name}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (/^[a-zA-Z\s]*$/.test(val)) {
                                  onValueChange(section.id, "first_name", val);
                                  clearValidationError(section.id);
                                }
                              }}
                              placeholder="First Name"
                              minLength={3}
                            />
                            {section.values.first_name && section.values.first_name.length < 3 && (
                              <div className="text-danger small mt-1">Min 3 characters required</div>
                            )}
                            {getFieldErrors(section.id, ["first name", "first_name"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["first name", "first_name"]).join('. ')}</div>
                            )}
                          </Col>
                          <Col md={4}>
                            <label className="form-label">Middle Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={section.values.middle_name}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (/^[a-zA-Z\s]*$/.test(val)) {
                                  onValueChange(section.id, "middle_name", val);
                                  clearValidationError(section.id);
                                }
                              }}
                              placeholder="Middle Name"
                              minLength={3}
                            />
                            {section.values.middle_name && section.values.middle_name.length < 3 && (
                              <div className="text-danger small mt-1">Min 3 characters required</div>
                            )}
                            {getFieldErrors(section.id, ["middle name", "middle_name"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["middle name", "middle_name"]).join('. ')}</div>
                            )}
                          </Col>
                          <Col md={4}>
                            <label className="form-label">Last Name</label>
                            <input
                              className="form-control"
                              value={section.values.last_name}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (/^[a-zA-Z\s]*$/.test(val)) {
                                  onValueChange(section.id, "last_name", val);
                                  clearValidationError(section.id);
                                }
                              }}
                              placeholder="Last Name"
                              minLength={3}
                            />
                            {section.values.last_name && section.values.last_name.length < 3 && (
                              <div className="text-danger small mt-1">Min 3 characters required</div>
                            )}
                            {getFieldErrors(section.id, ["last name", "last_name"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["last name", "last_name"]).join('. ')}</div>
                            )}
                          </Col>
                        </>
                      )}

                      {section.field === "dob" && (
                        <>
                          <Col xs={12} />
                          <Col md={4}>
                            <label className="form-label">DOB</label>
                            <input
                              type="date"
                              className="form-control"
                              value={section.values.dob}
                              onChange={(e) => { onValueChange(section.id, "dob", e.target.value); clearValidationError(section.id); }}
                              placeholder="YYYY-MM-DD"
                              max={new Date().toISOString().split("T")[0]}
                            />
                            {getFieldErrors(section.id, ["dob"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["dob"]).join('. ')}</div>
                            )}
                          </Col>
                        </>
                      )}
                      {section.field === "dob" && (
                        <div className="text-danger mt-2">
                          Note: This field can be edited only once. Please update carefully.
                        </div>
                      )}

                      {section.field === "address" && (
                        <>
                          <Col xs={12} />

                          <Col md={4}>
                            <label className="form-label">District</label>
                            <select
                              className="form-select"
                              value={section?.values?.district}
                              onChange={(e) => {
                                onValueChange(section.id, "district", e.target.value);
                                clearValidationError(section.id);
                              }}
                            >
                              <option value="">Select District</option>
                              {districtList.map((dt) => (
                                <option key={dt.id} value={dt.id}>
                                  {dt.name}
                                </option>
                              ))}
                            </select>
                          </Col>

                          <Col md={4}>
                            <label className="form-label">Pincode<span className="text-danger">*</span></label>
                            <input
                              type="number"
                              className="form-control"
                              value={section?.values?.pincode}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val.length <= 6) {
                                  onValueChange(section.id, "pincode", val);
                                  clearValidationError(section.id);
                                }
                              }}
                              placeholder="Pincode"
                            />
                            {section.values.pincode && !/^[1-9][0-9]{5}$/.test(section.values.pincode) && (
                              <div className="text-danger small mt-1">
                                Invalid Pincode (Must be 6 digits, can't start with 0).
                              </div>
                            )}
                            {getFieldErrors(section.id, ["pincode"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["pincode"]).join('. ')}</div>
                            )}
                          </Col>
                          <Col md={4}>
                            <label className="form-label">Landmark</label>
                            <input
                              className="form-control"
                              value={section.values.landmark}
                              onChange={(e) => {
                                const val = e.target.value;
                                // Allow alphanumeric, spaces, and basic address punctuation
                                if (/^[a-zA-Z\s]*$/.test(val)) {
                                  onValueChange(section.id, "landmark", val);
                                  clearValidationError(section.id);
                                }
                              }}
                              placeholder="Landmark"
                              minLength={3}
                            />
                            {getFieldErrors(section.id, ["landmark"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["landmark"]).join('. ')}</div>
                            )}
                          </Col>
                          <Col md={4}>
                            <label className="form-label">Full Address</label>
                            <input
                              className="form-control"
                              value={section.values.address}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (/^[a-zA-Z\s]*$/.test(val)) {
                                  onValueChange(section.id, "address", val);
                                  clearValidationError(section.id);
                                }
                              }}
                              placeholder="Full Address"
                              minLength={3}
                            />
                            {getFieldErrors(section.id, ["address", "full address"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["address", "full address"]).join('. ')}</div>
                            )}
                          </Col>
                        </>
                      )}

                      {section.field === "state" && (
                        <>
                          <Col xs={12} />
                          <Col md={4}>
                            <label className="form-label">State</label>
                            <select
                              className="form-select"
                              value={section?.values?.state}

                              onChange={(e) => {
                                onStateChange(section.id, e.target.value);
                                clearValidationError(section.id);
                              }}
                            >
                              <option value="">Select State</option>
                              {stateList.map((st) => (
                                <option key={st.id} value={st.id}>
                                  {st.name}
                                </option>
                              ))}
                            </select>
                          </Col>
                          <div className="text-danger mt-2">
                            Note: This field can be edited only once. Please update carefully.
                          </div>
                        </>
                      )}

                      {section.field === "profile" && (
                        <>
                          <Col xs={12}>
                            <label className="form-label">Previous Photo</label>
                            <div className="d-flex align-items-center gap-2">
                              <div
                                style={{
                                  width: 100,
                                  height: 100,
                                  borderRadius: 8,
                                  border: "1px solid #E5E7EB",
                                  background: "#F9FAFB",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  overflow: "hidden",
                                }}
                              >
                                {(section.values.photofileUrl || userProfileImage) ? (
                                  <img
                                    src={section.values.photofileUrl || userProfileImage}
                                    alt="uploaded preview"
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                  />
                                ) : (
                                  <span className="text-muted"><HugeiconsIcon icon={Image02Icon} /></span>
                                )}
                              </div>
                            </div>
                          </Col>
                        </>
                      )}

                      {section.field === "identification" && (
                        <>
                          <Col xs={12} />
                          <Col md={4}>
                            <label className="form-label">Identification Type <span className="text-danger">*</span></label>
                            <select
                              className="form-select"
                              value={section.values.identification_type}
                              onChange={(e) => { onValueChange(section.id, "identification_type", e.target.value); clearValidationError(section.id); }}
                            >
                              <option value="">Select Here</option>
                              <option value="aadhaar">Aadhaar Card</option>
                              <option value="pan_card">Pan Card</option>
                            </select>
                            {getFieldErrors(section.id, ["identification type"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["identification type"]).join('. ')}</div>
                            )}
                          </Col>
                          <Col md={4}>
                            <label className="form-label">Identification Number <span className="text-danger">*</span></label>
                            <input
                              className="form-control "
                              type={section.values.identification_type === "aadhaar" ? "number" : "text"}
                              minLength={section.values.identification_type === "aadhaar" ? 12 : 10}
                              maxLength={section.values.identification_type === "aadhaar" ? 12 : 10}
                              value={section.values.identification_number}
                              onChange={(e) => { onValueChange(section.id, "identification_number", e.target.value.toUpperCase()); clearValidationError(section.id); }}
                              placeholder={
                                section.values.identification_type === "aadhaar" ? "Enter Aadhaar Number" :
                                  section.values.identification_type === "pan_card" ? "Enter Pan Number" :
                                    "Identification Number"
                              }
                            />
                            {getFieldErrors(section.id, ["identification number", "aadhaar", "pan"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["identification number", "aadhaar", "pan"]).join('. ')}</div>
                            )}
                          </Col>
                          <div className="text-danger mt-2">
                            Note: This field can be edited only once. Please update carefully.
                          </div>
                        </>
                      )}

                      {section.field === "kit_size" && (
                        <>
                          <Col xs={12} />
                          <Col md={4}>
                            <label className="form-label">Kit Size</label>
                            <select
                              className="form-select"
                              value={section.values.kit_size}
                              onChange={(e) => {
                                onValueChange(section.id, "kit_size", e.target.value);
                                clearValidationError(section.id);
                              }}
                            >
                              <option value="">Select Kit Size</option>
                              {kitSizeList.map((size) => (
                                <option key={size.id} value={size.id}>
                                  {size.size_name}
                                </option>
                              ))}
                            </select>
                            {getFieldErrors(section.id, ["kit size", "kit_size", "kit"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["kit size", "kit_size", "kit"]).join('. ')}</div>
                            )}
                          </Col>
                        </>
                      )}

                      {section.field === "shoe_size" && (
                        <>
                          <Col xs={12} />
                          <Col md={4}>
                            <label className="form-label">Shoe Size</label>
                            <select
                              className="form-select"
                              value={section.values.shoe_size}
                              onChange={(e) => {
                                onValueChange(section.id, "shoe_size", e.target.value);
                                clearValidationError(section.id);
                              }}
                            >
                              <option value="">Select Shoe Size</option>
                              {shoeSizingGuide.map((size) => (
                                <option key={size.uk} value={size.uk}>
                                  UK {size.uk} (EU {size.eu}, US {size.us})
                                </option>
                              ))}
                            </select>

                          </Col>
                        </>
                      )}

                      {section.field === "height" && (
                        <>
                          <Col xs={12} />
                          <Col md={4}>
                            <label className="form-label">Height (cm) <span className="text-danger">*</span></label>
                            <input
                              type="number"
                              className="form-control"
                              value={section.values.height}
                              onKeyDown={(e) => {
                                // Prevent minus, plus, and 'e' characters
                                if (e.key === '-' || e.key === '+' || e.key === 'e' || e.key === 'E') {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                const val = e.target.value;
                                // Allow empty or valid positive numbers up to 3 digits
                                if (val === '' || (/^\d{1,3}$/.test(val) && parseInt(val) > 0)) {
                                  onValueChange(section.id, "height", val);
                                  clearValidationError(section.id);
                                }
                              }}
                              placeholder="e.g., 175"
                              min="1"
                              max="999"
                            />
                            {section.values.height && (parseInt(section.values.height) <= 0 || section.values.height.length > 3) && (
                              <div className="text-danger small mt-1">Height must be a positive number with maximum 3 digits</div>
                            )}
                            {getFieldErrors(section.id, ["height"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["height"]).join('. ')}</div>
                            )}
                          </Col>
                        </>
                      )}

                      {section.field === "weight" && (
                        <>
                          <Col xs={12} />
                          <Col md={4}>
                            <label className="form-label">Weight (kg) <span className="text-danger">*</span></label>
                            <input
                              type="number"
                              className="form-control"
                              value={section.values.weight}
                              onKeyDown={(e) => {
                                // Prevent minus, plus, and 'e' characters
                                if (e.key === '-' || e.key === '+' || e.key === 'e' || e.key === 'E') {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                const val = e.target.value;
                                // Allow empty or valid positive numbers up to 3 digits
                                if (val === '' || (/^\d{1,3}$/.test(val) && parseInt(val) > 0)) {
                                  onValueChange(section.id, "weight", val);
                                  clearValidationError(section.id);
                                }
                              }}
                              placeholder="e.g., 70"
                              min="1"
                              max="999"
                            />
                            {section.values.weight && (parseInt(section.values.weight) <= 0 || section.values.weight.length > 3) && (
                              <div className="text-danger small mt-1">Weight must be a positive number with maximum 3 digits</div>
                            )}
                            {getFieldErrors(section.id, ["weight"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["weight"]).join('. ')}</div>
                            )}
                          </Col>
                        </>
                      )}

                      {section.field === "blood_group" && (
                        <>
                          <Col xs={12} />
                          <Col md={4}>
                            <label className="form-label">Blood Group <span className="text-danger">*</span></label>
                            <select
                              className="form-select"
                              value={medicalHistory?.data?.blood_group}
                              onChange={(e) => { onValueChange(section.id, "blood_group", e.target.value); clearValidationError(section.id); }}
                            >
                              <option value="">Select Blood Group</option>
                              <option value="A+">A+</option>
                              <option value="A-">A-</option>
                              <option value="B+">B+</option>
                              <option value="B-">B-</option>
                              <option value="AB+">AB+</option>
                              <option value="AB-">AB-</option>
                              <option value="O+">O+</option>
                              <option value="O-">O-</option>
                            </select>
                            {getFieldErrors(section.id, ["blood group", "blood_group"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["blood group", "blood_group"]).join('. ')}</div>
                            )}
                          </Col>
                          <div className="text-danger mt-2">
                            Note: This field can be edited only once. Please update carefully.
                          </div>
                        </>
                      )}

                      {section.field === "sport" && (
                        <>
                          <Col xs={12} />
                          <Col md={4}>
                            <label className="form-label">Select Sport <span className="text-danger">*</span></label>
                            <SportFilter
                              value={section.values.sport_id}
                              onChange={(e) => {
                                onValueChange(section.id, "sport_id", e.target.value);
                                clearValidationError(section.id);
                              }}
                              required={true}
                              disabled={false}
                            />
                            {getFieldErrors(section.id, ["sport"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["sport"]).join('. ')}</div>
                            )}
                          </Col>
                          <div className="text-danger mt-2">
                            Note: This field can be edited only once. Please update carefully.
                          </div>
                        </>
                      )}

                      {section.field === "user_type" && (
                        <>
                          <Col xs={12} />
                          <Col md={4}>
                            <label className="form-label">Category <span className="text-danger">*</span></label>
                            <select
                              className="form-select"
                              value={section.values.category_type_id || ""}
                              onChange={(e) => {
                                onValueChange(section.id, "category_type_id", e.target.value);
                                onValueChange(section.id, "sub_category_type_id", "");
                                onCategoryTypeChange(section.id, e.target.value);
                                clearValidationError(section.id);
                              }}
                            >
                              <option value="">Select Category</option>
                              {(categoryTypes[section.values.category_main_id] || []).map((t) => (
                                <option key={t.id} value={t.id}>{t.category_name || t.name}</option>
                              ))}
                            </select>
                          </Col>

                          {section.values.category_type_id && (
                            <Col md={4}>
                              <label className="form-label">Sub-Category</label>
                              <select
                                className="form-select"
                                value={section.values.sub_category_type_id || ""}
                                onChange={(e) => {
                                  onValueChange(section.id, "sub_category_type_id", e.target.value);
                                  clearValidationError(section.id);
                                }}
                              >
                                <option value="">Select Sub-Category</option>
                                {(subCategories[section.values.category_type_id] || []).map((s) => (
                                  <option key={s.id} value={s.id}>{s.sub_category_name || s.name}</option>
                                ))}
                              </select>
                            </Col>
                          )}

                          <div className="text-danger mt-2">
                            Note: Changing user type may affect your access and permissions.
                          </div>
                        </>
                      )}

                      {section.field === "bank_details" && (
                        <>
                          <Col xs={12} />
                          <Col md={4}>
                            <label className="form-label">Bank Name<span className="text-danger">*</span></label>
                            <input
                              className="form-control"
                              value={section.values.bank_name}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (/^[a-zA-Z\s]*$/.test(val)) {
                                  onValueChange(section.id, "bank_name", val);
                                  clearValidationError(section.id);
                                }
                              }}
                              placeholder="Bank Name"
                              minLength={3}
                            />
                            {section.values.bank_name && section.values.bank_name.length < 3 && (
                              <div className="text-danger small mt-1">Min 3 characters required</div>
                            )}
                            {getFieldErrors(section.id, ["bank name", "bank_name"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["bank name", "bank_name"]).join('. ')}</div>
                            )}
                          </Col>
                          <Col md={4}>
                            <label className="form-label">Account Holder Name<span className="text-danger">*</span></label>
                            <input
                              className="form-control"
                              value={section.values.account_holder_name}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (/^[a-zA-Z\s]*$/.test(val)) {
                                  onValueChange(section.id, "account_holder_name", val);
                                  clearValidationError(section.id);
                                }
                              }}
                              placeholder="Account Holder Name"
                              minLength={3}
                            />
                            {section.values.account_holder_name && section.values.account_holder_name.length < 3 && (
                              <div className="text-danger small mt-1">Min 3 characters required</div>
                            )}
                            {getFieldErrors(section.id, ["account holder", "account_holder_name"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["account holder", "account_holder_name"]).join('. ')}</div>
                            )}
                          </Col>
                          <Col md={4}>
                            <label className="form-label">Account Number<span className="text-danger">*</span></label>
                            <input
                              type="number"
                              className="form-control"
                              value={section.values.account_number}
                              onChange={(e) => {
                                onValueChange(section.id, "account_number", e.target.value);
                                clearValidationError(section.id);
                              }}
                              placeholder="Account Number"
                            />
                            {getFieldErrors(section.id, ["account number", "account_number"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["account number", "account_number"]).join('. ')}</div>
                            )}
                          </Col>
                          <Col md={4}>
                            <label className="form-label">Branch Name<span className="text-danger">*</span></label>
                            <input
                              className="form-control"
                              value={section.values.branch_name}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (/^[a-zA-Z\s]*$/.test(val)) {
                                  onValueChange(section.id, "branch_name", val);
                                  clearValidationError(section.id);
                                }
                              }}
                              placeholder="Branch Name"
                              minLength={3}
                            />
                            {section.values.branch_name && section.values.branch_name.length < 3 && (
                              <div className="text-danger small mt-1">Min 3 characters required</div>
                            )}
                            {getFieldErrors(section.id, ["branch name", "branch_name"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["branch name", "branch_name"]).join('. ')}</div>
                            )}
                          </Col>
                          <Col md={4}>
                            <label className="form-label">IFSC Code<span className="text-danger">*</span></label>
                            <input
                              className="form-control"
                              value={section.values.ifsc_code}
                              maxLength={11}
                              onChange={(e) => {
                                const val = e.target.value.toUpperCase();
                                // Allow only alphanumeric
                                if (/^[A-Z0-9]*$/.test(val) && val.length <= 11) {
                                  onValueChange(section.id, "ifsc_code", val);
                                  clearValidationError(section.id);
                                }
                              }}
                              placeholder="IFSC Code"
                            />
                            {section.values.ifsc_code && (
                              (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(section.values.ifsc_code) || section.values.ifsc_code.length !== 11) && (
                                <div className="text-danger small mt-1">
                                  Invalid Format (e.g. ABCD0123456). Must be 11 chars.
                                </div>
                              )
                            )}
                            {getFieldErrors(section.id, ["ifsc", "ifsc_code"]).length > 0 && (
                              <div className="text-danger small mt-1">{getFieldErrors(section.id, ["ifsc", "ifsc_code"]).join('. ')}</div>
                            )}
                          </Col>
                        </>
                      )}

                      {/* Upload supportive document - Only show for specific fields */}
                      {["bank_details", "dob", "name", "profile", "identification"].includes(section.field) && (
                        <Col md={12}>
                          <label className="form-label">
                            {section.field === "bank_details" ? "Upload Cancelled Cheque/Passbook" : "Upload Supportive Document"}
                            {" "}<span className="text-danger">*</span>
                          </label>

                          <div style={{ position: 'relative', }}>
                            <div className="d-flex align-items-center gap-2 ">
                              <div
                                style={{
                                  width: 50,
                                  height: 50,
                                  borderRadius: 8,
                                  border: "2px solid #E5E7EB",
                                  background: "#F9FAFB",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  overflow: "hidden",
                                }}
                              >
                                {/* {section.values.fileUrl ? (
                                  <img
                                    src={section.values.fileUrl}
                                    alt="uploaded preview"
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                  />
                                ) : (
                                  <span className="text-muted"><HugeiconsIcon icon={Image02Icon} size={32} /></span>
                                )} */}

                                {section.values.fileUrl ? (
                                  section.values.fileUrl?.toLowerCase()?.includes(".pdf") ? (
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                        color: "red",
                                      }}
                                    >
                                      PDF
                                    </div>
                                  ) : (
                                    <img
                                      src={section.values.fileUrl}
                                      alt="uploaded preview"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  )
                                ) : (
                                  <span className="text-muted"><HugeiconsIcon icon={Image02Icon} size={32} /></span>
                                )}
                              </div>

                              {section.values.fileUrl && (
                                <>
                                  <a
                                    href={section.values.fileUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-outline-secondary btn-sm"
                                  >
                                    View File
                                  </a>
                                  <span className="text-muted small">Selected File</span>
                                </>
                              )}

                              {!section.values.fileUrl && (
                                <>
                                  <label className="btn btn-outline-primary btn-sm mb-0" style={{ cursor: 'pointer' }}>
                                    Browse
                                    <input
                                      type="file"
                                      accept="image/png,image/jpg,image/jpeg"
                                      hidden
                                      onChange={(e) => {
                                        onFileChange(section.id, e.target.files?.[0] || null);
                                        clearValidationError(section.id);
                                      }}
                                    />
                                  </label>
                                  <span className="text-muted small">
                                    {section.values.uploading ? "Uploading..." :
                                      section.values.uploadSuccess ? "Uploaded Successfully" :
                                        section.values.uploadError ? "Upload Failed" :
                                          "No File Chosen"}
                                  </span>
                                </>
                              )}
                            </div>

                            {/* Delete icon - positioned absolutely */}
                            {section.values.fileUrl && (
                              <span
                                style={{
                                  position: "absolute",
                                  top: "-8px",
                                  left: "38px",
                                  color: "#EF4444",
                                  cursor: "pointer",
                                  fontSize: "15px",
                                  backgroundColor: "white",
                                  borderRadius: "40%",
                                  zIndex: 10,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "15px",
                                  height: "15px",
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                }}
                                onClick={() => handleRemoveFile(section.id)}
                                title="Remove file"
                              >
                                <i className="bi bi-x-circle-fill"></i>
                              </span>
                            )}
                          </div>

                          <div className="form-text mt-2">File Supported: PNG, JPG ,PDF & JPEG max 2MB</div>
                          {getFieldErrors(section.id, ["document", "file", "supportive"]).length > 0 && (
                            <div className="text-danger small mt-1">{getFieldErrors(section.id, ["document", "file", "supportive"]).join('. ')}</div>
                          )}
                        </Col>
                      )}
                    </>
                  )}
                </Row>
              </div>
            );
          })}

          {/* Only show "Change More Details" button if at least one field is selected */}
          {sections.some(s => s.field) && (
            <div className="mb-3">
              <Button type="button" variant="light" className="d-flex w-25 add-more-btn text-start gap-1" onClick={onAddSection}>
                <HugeiconsIcon icon={AddSquareIcon} size={18} />Change More Details
              </Button>
            </div>
          )}


          {/* Only show Submit button if at least one field is selected */}
          {sections.some(s => s.field) ? (
            <Button type="submit" className="gradient-btn w-100" disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Submit"}
            </Button>
          ) : (<Button type="submit" className="gradient-edit-btn w-100" disabled={false}>
            {"Update Details"}
          </Button>)}
        </form>
      </Card.Body>
    </Card>
  );
}